import { useEffect, useState } from 'react'

import { basketUpsellFetcher, type BasketUpsellResponse } from '@library/api-menu-experience'

type UseFetchBasketUpsellInput = {
  basketDate?: string
  enabled: boolean
  menuUuid?: string
  numPortions: number
  postcode?: string
  selectedRecipeIds: string[]
}

export const useFetchBasketUpsell = ({
  basketDate,
  enabled,
  menuUuid,
  numPortions,
  postcode,
  selectedRecipeIds,
}: UseFetchBasketUpsellInput) => {
  const [response, setResponse] = useState<BasketUpsellResponse | null>(null)
  const [hasFailed, setHasFailed] = useState(false)

  useEffect(() => {
    if (!enabled || !menuUuid || !basketDate || !postcode) {
      setResponse(null)
      setHasFailed(false)

      return undefined
    }

    let isCurrent = true

    setResponse(null)
    setHasFailed(false)

    const loadBasketUpsell = async () => {
      try {
        const basketUpsellResponse = await basketUpsellFetcher({
          menuId: menuUuid,
          numPortions,
          deliveryDate: basketDate,
          postcode,
          recipeIds: selectedRecipeIds,
        })

        if (!isCurrent) return

        setHasFailed(false)
        setResponse(basketUpsellResponse)
      } catch {
        if (!isCurrent) return

        setHasFailed(true)
        setResponse(null)
      }
    }

    loadBasketUpsell()

    return () => {
      isCurrent = false
    }
  }, [basketDate, enabled, menuUuid, numPortions, postcode, selectedRecipeIds])

  return {
    hasFailed,
    response,
  }
}
